import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ActionMode, StateDefinitionType } from 'src/app/model';
import { DtcServiceService } from 'src/app/modules/dtc/dtc-service.service';
import { DataService, ServicecallService } from 'src/app/services';
import { CaseServiceService } from '../../../../../../modules/case/case-service.service';
@Component({
  selector: 'app-case-listing',
  templateUrl: './case-listing.component.html',
  styleUrl: './case-listing.component.css'
})
export class CaseListingComponent implements OnInit, OnDestroy {

  @Input() selectedState: string;
  @Input() entityData : any;
  @Input() selectedDtc: any;
  @Input() pageType: string;
  @Input() stateDefinition : StateDefinitionType;
  @Input() caseFilters : any;
  @Input() searchKey: string;
  @Input() fromDate: number;  
  @Input() toDate:   number;
  @Input() setLabel: string;
  @Input() dtcType: string;
  @Output() caseClosed = new EventEmitter<any>();
  syncError : boolean = false;

  tenantConfig: any;
  caseListData: any = [];
  pager: any;
  currentPage: number = 1;
  totalPages: number[];
  endPage: boolean = false;
  public isOpenForm: boolean = false;
  public selectedCase: any;
  public limit: number = 10;
  private _entitiesMarkerList: any = [];

  //Subscription
  private _caseListingSubscription: Subscription;
  private _subscription: Subscription;
  private _checkPortusSubscription : Subscription;
  private _updateDtcSubscription: Subscription;

  modalData: { type: string; formStatus: ActionMode; data: { dtcDetails: any; vehicleGroup: { fuelType: string, engineModel: string[], emissionNorm: string[]} , specification : { severity: string, ruleCategory: string, caseRules : any}}; };
  showModal: boolean = false;

  constructor(public _sharedService: ServicecallService, private _caseService: CaseServiceService, private _datePipe: DatePipe, private _dataSer: DataService, private _dtcService: DtcServiceService) {
    this._subscription = this._dataSer?.events?.subscribe((res: any) => {
      if (res?.name === 'siteChanged' || res?.name === 'apiRefresh') {
        this.getCaseListing(this.currentPage);
      }
    });
   }

  ngOnInit(): void {
    this._entitiesMarkerList = this._sharedService.getConfiguration('trackerEntities') ? this._sharedService.getConfiguration('trackerEntities')['trackerEntitiesList'] : [];
    this.tenantConfig = this._sharedService?.getConfiguration('tenantGenericConfig') ? this._sharedService?.getConfiguration('tenantGenericConfig') : null;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['fromDate'] || changes['toDate'] || changes['selectedState'] || changes['caseFilters'] || changes['searchKey'] || changes['dtcType']) {
      setTimeout(() => {
        this.currentPage = 1;
        this.getCaseListing(1);
      }, 0);
    }
  }

  ngOnDestroy(): any {
    this._caseListingSubscription?.unsubscribe();
    this._subscription?.unsubscribe();
    this._checkPortusSubscription?.unsubscribe();
    this._updateDtcSubscription?.unsubscribe();
  }

  onPaginateChange(page: any) {
    this.currentPage = page;
    document.getElementById("launchScroll")?.scrollIntoView({ behavior: "smooth" });
    this.getCaseListing(this.currentPage);
  }

  onPageSizeChange(limit: number) {
    this.limit = limit;
    this.currentPage = 1;
    this.getCaseListing(1);
  }

  tableAction(event: any) {
    if (event?.type === 'dtcDrilldown') {
      if(event?.item?.type === 'DTC') {
        if(event?.item?.protusNumber && event?.item?.originalState !== 'closed') {
          this.checkStatusOfCase(event);
        } else {
          this.isOpenForm = true;
          this.selectedCase = event?.item;
          this.syncError = false;
        }
      } else {
        this.showModal = true;
        const defaultDtcData = event?.item?.dtcBlock;
        this.modalData = {type: 'dtcDrilldown', formStatus: ActionMode.UPDATE , data: 
        {
          dtcDetails: {
            dtc: defaultDtcData?.dtc ?? null,
            name: defaultDtcData?.name ?? null,
            description : defaultDtcData?.description ?? null,
            fmi: event?.item?.fmi ?? null,
            spn: event?.item?.spn ?? null,
            _id: event?.item?.dtcId ?? null
          }, 
          vehicleGroup: {...defaultDtcData?.vehicleGroup} ?? null,
          specification: {
            severity : defaultDtcData?.severity ?? null,
            ruleCategory: defaultDtcData?.ruleCategory ?? null,
            caseRules: {...defaultDtcData?.caseRules} ?? null
          }
      } }
      }
    } else if (event?.type === 'downloadCase') {
      this.activeEntityExport(event?.item)
    } else if (event?.type === 'export') {
      const fileType = event?.item;
      let reqParam: any = {
        timezone: sessionStorage.getItem('selectedTimeZone') ? sessionStorage.getItem('selectedTimeZone') : moment.tz.guess(),
        exportFormat: fileType,
        exportFilename: "Case data",
        limit: Number(this.limit),
        fields: this._sharedService.getConfiguration('exportGenericConfig') ? this._sharedService.getConfiguration('exportGenericConfig')?.case : []
      };
      if (this.fromDate != null && this.toDate != null) {
        const fromStr = this._datePipe.transform(this.fromDate, 'yyyy-MM-ddTHH:mm:ssZZ')!;
        const toStr   = this.setLabel === 'Yesterday' || this.setLabel === 'Custom' //Applying current date if date range is not Yesterday/Custom
        ? this._datePipe.transform(new Date(this.toDate),   'yyyy-MM-ddTHH:mm:ssZZ') 
        : this._datePipe.transform(new Date()?.setSeconds(new Date()?.getSeconds() + 5),   'yyyy-MM-ddTHH:mm:ssZZ'); //Adding 5 second to capture the state update 
        
        reqParam.range = { from: fromStr, to: toStr };
      } else {
        reqParam.range = {
          from: this._datePipe.transform( new Date().setDate(new Date().getDate() - 30), 'yyyy-MM-ddTHH:mm:ssZ'),
          to: this._datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZ')
        }
      }
      if (this.caseFilters && Object.keys(this.caseFilters)?.length) {
        const { state, type, ...restFilters } = this.caseFilters ?? {};
        reqParam = { 
          ...reqParam, 
          ...(this.caseFilters.state && {state: this.caseFilters.state?.filter(item => item.state !== 'total')}),
          ...(type && {type: type?.[0]}),
          ...restFilters
        };
      }
      if (this.searchKey) {
        reqParam.searchKey = this.searchKey;
      }
      if(this.entityData?._id){
        reqParam.entityId = this.entityData?._id
      }
      if(this.selectedDtc?.dtc){
        reqParam.dtcId = this.selectedDtc?._id
      }
      if(this.dtcType) {
        reqParam = {
          ...reqParam,
          ...(this.dtcType && {type: this.dtcType})
        }
      }
      this._sharedService.commonExport(fileType, reqParam, 'caseExport', 'Export_Case_');
    } else if(event?.type === 'suppressDtc') {
      const reqPayload = {
        fmi: event?.item?.fmi,
        spn: event?.item?.spn,
        caseRules: {
          triggerCase: false,
          allowDuplicates: event?.item?.caseRules?.allowDuplicates ?? false
        }
      }
      const _id = event?.item?.dtcId;
      this._updateDtcSubscription = this._dtcService.updateDtc(reqPayload, _id)?.subscribe(
        {
          next: () => {
            this._sharedService.toasterService({
              type: 'success',
              msg: 'DTC updated successfully'
            });
            this.getCaseListing(this.currentPage);
          }, error: () => {
            this._sharedService.toasterService({
              type: 'error',
              msg: Messages.ERROR
            });
          }
        });
    }
  }


  /**
   * Checks status of case
   * @param event 
   */
  checkStatusOfCase(event: any) {
    const casesStates = this._sharedService.getConfiguration('tenantGenericConfig')?.case?.caseState ? this._sharedService.getConfiguration('tenantGenericConfig')?.case?.caseState : [];
    //Integrate API here
    const reqPayload = { protusNumber: event?.item?.protusNumber};
    this._checkPortusSubscription = this._caseService.checkProtusStatus(reqPayload)?.subscribe(
      {
        next: (response: any) => {
          this.selectedCase = {...event?.item};
          if(response?.state && response?.protusNumber) {
            this.selectedCase = {...this.selectedCase, originalState: response.state, state: casesStates?.find(dtc => dtc?.category === response.state)?.name,  rca: response?.rca};
          }
          this.isOpenForm = true;
          this.syncError = false;
        }, error: () => {
          this.isOpenForm = true;
          this.selectedCase = event?.item;
          this.syncError = true;
        }
      });

  }

  activeEntityExport(selectedCase: any) {
    const startDate = this.getDate5DaysBehind(selectedCase?.metadata?.createdDate);
    const endDate = new Date(selectedCase?.metadata?.createdDate);
    const reqParam = {
      from: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: selectedCase?.entityId,
      exportFormat: 'csv',
      timezone: sessionStorage.getItem('selectedTimeZone') ? sessionStorage.getItem('selectedTimeZone') : moment.tz.guess(),
      exportFilename: 'Telematics History',
      fields: this._sharedService.getConfigurationBasedOnCategory(selectedCase?.entity, 'export') ?
      this._sharedService.getConfigurationBasedOnCategory(selectedCase?.entity, 'export')?.export?.telematicsHistory : []
    }
    this._sharedService.commonExport(selectedCase, reqParam, 'activeEntityExport', 'Export_Telematics_History_')
  }

  getDate5DaysBehind(providedDate: string) {
    const date = new Date(providedDate);
    date.setDate(date.getDate() - 5); 
    return date; 
  }

  getCaseListing(pageNo: any, event?: number) {
    const casesStates = this._sharedService.getConfiguration('tenantGenericConfig')?.case?.caseState ? this._sharedService.getConfiguration('tenantGenericConfig')?.case?.caseState : [];
    let reqPayload: any = {}
    if (this.fromDate != null && this.toDate != null) {
      const fromStr = this._datePipe.transform(this.fromDate, 'yyyy-MM-ddTHH:mm:ssZZ')!;
      const toStr   = this.setLabel === 'Yesterday' || this.setLabel === 'Custom' //Applying current date if date range is not Yesterday/Custom
      ? this._datePipe.transform(new Date(this.toDate),   'yyyy-MM-ddTHH:mm:ssZZ') 
      : this._datePipe.transform(new Date()?.setSeconds(new Date()?.getSeconds() + 5),   'yyyy-MM-ddTHH:mm:ssZZ'); //Adding 5 second to capture the state update 
      
      reqPayload.range = { from: fromStr, to: toStr };
    }
    if (this.selectedState && this.selectedState !== 'total') {
      reqPayload.state = this.selectedState ? [this.selectedState] : []
    }
    reqPayload.limit = Number(this.limit); 
    if(this.entityData?._id){
      reqPayload.entityId = this.entityData?._id
    }
    if(this.selectedDtc?.dtc){
      reqPayload.dtcId = this.selectedDtc?._id
    }
    if (this.caseFilters && Object.keys(this.caseFilters)?.length) {
      const { state, type, ...restFilters } = this.caseFilters ?? {};
      reqPayload = { 
        ...reqPayload, 
        ...(this.caseFilters.state && {state: this.caseFilters.state?.filter(item => item.state !== 'total')}),
        ...(type && {type: type?.[0]}),
        ...restFilters
      };
    }
    if(this.dtcType) {
      reqPayload = {
        ...reqPayload,
        ...(this.dtcType && {type: this.dtcType})
      }
    }
    if(this.searchKey){
      reqPayload.searchKey = this.searchKey;
    }
    this._caseListingSubscription = this._caseService.getCaseList(pageNo, reqPayload)?.subscribe(
      {
        next: (response: any) => {
          if (response?.data?.length) {
            this.caseListData = [...response?.data];
            this.caseListData = this.caseListData?.map((item: any) => {
              const entity = item?.['entity'] || {};
              const dtc = item?.['dtc'] || {};
              const primaryDetails = entity?.primaryDetails || {};
              const secondaryDetails = entity?.secondaryDetails || {};
              item.dtcBlock = {...dtc};
              item.entityModule = this._setEntityType(entity?.category);
              item.entityType = 'case';
              item.originalState = item.state;
              item.state = casesStates?.find(dtc => dtc?.category === item?.state)?.name;
              item.sourceTimestamp = item?.metadata?.createdDate;
              item.time = this._sharedService?.getLastSeenFormat(item?.metadata?.createdDate);    
              item.caseId = item?._id;
              item.entityCategory = secondaryDetails?.section ?? '';
              item.caseCategory = this.tenantConfig?.case?.translate?.[item?.type] ?? item?.type;
              dtc.dtc = (item?.type === 'DTC' || dtc?.dtc ) ? dtc?.dtc : 'Unknown';
              item.dtcId = item?.dtcId ?? dtc?._id;
              item.closedBy = item?.originalState === 'closed' ? item?.metadata?.modifiedBy?.userName : "--";
              return {...item,...entity,...dtc,...primaryDetails,...secondaryDetails};
            })
          } else {
            this.caseListData = [];
          };
          if (response['pageInfo']) {
            this.pager = { ...response['pageInfo'] };
            this.totalPages = response?.pageInfo?.pages?.length ? response?.pageInfo?.pages : []
            this.endPage = response?.pageInfo?.endPage;
          } else {
            this.pager = null;
            this.totalPages = [];
            this.endPage = false;
          }
        }, error: (error: any) => {
          this.caseListData = [];
          this.pager = null;
          this.totalPages = [];
          this.endPage = false;
        }
      });
  }

    /**
 * Sets entity type
 * @param category 
 * @returns  
 */
     private _setEntityType(category: any) {
      const filteredEntityEntityModule = this._entitiesMarkerList.find((entity: any) => entity.entityCategory === category);
      return filteredEntityEntityModule ? this._setRoute(+filteredEntityEntityModule.entityModule) : '';
    }
  
    /**
     * Sets route
     * @param entityModule 
     * @returns  
     */
    private _setRoute(entityModule: number) {
      switch (entityModule) {
        case 1: return 'vehicles';
        case 2: return 'assets';
        case 3: return 'people';
        default: return 'assets';
      }
    }
  

  handleCaseForm(event: boolean) {
    this.isOpenForm = event;
    this.caseClosed.emit(true);
    this.getCaseListing(this.currentPage);
  }

  closePopover(event: any) {
    this.showModal = false;
    if(event) {
      this.getCaseListing(this.currentPage);
    }
  }

  emitDetail() {
    return this.isOpenForm;
  }

  emitAddDtcForm() {
    return this.showModal;
  }

}
